/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_TitleInputs */

const en_admin_payments_title = /** @type {(inputs: Admin_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const zh_admin_payments_title = /** @type {(inputs: Admin_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付管理`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Admin_Payments_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_title = /** @type {((inputs?: Admin_Payments_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_title(inputs)
	return zh_admin_payments_title(inputs)
});
export { admin_payments_title as "admin.payments.title" }